/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import Collapse from "react-bootstrap/Collapse";
import { ChromePicker } from "react-color";
import { toast } from "react-hot-toast";
import { useDispatch } from "react-redux";
import Card from "../../../../../components/Cards/Card";
import { getMobileDomainBrandIdentity } from "../../../../../store/actions/manager.action";
import { ManagerService } from "../../../../../utils/services/manager.service";

function Color({ dictionary, domainBrand, domainMobile }) {
  const dispatch = useDispatch();
  const [open] = useState(false);
  const [color, setColor] = useState(false);
  const [loading, setLoading] = useState(false);
  const [colorPallet, setColorPallet] = useState({
    mobileMainBackgroundColour: domainMobile?.mobileMainBackgroundColour,
    mobileLaunchScreenHeaderColour:
      domainMobile?.mobileLaunchScreenHeaderColour,
    mobileSubPagesColour: domainMobile?.mobileSubPagesColour,
    mobileMainFooterColour: domainMobile?.mobileMainFooterColour,
    mobileMenuBarColour: domainMobile?.mobileMenuBarColour,
    mobileBorderLineColour: domainMobile?.mobileBorderLineColour,
    mobileDividerLineColour: domainMobile?.mobileDividerLineColour,
    mobileMainLoginBoxButtonColour:
      domainMobile?.mobileMainLoginBoxButtonColour,
    mobileOtherButtonColour: domainMobile?.mobileOtherButtonColour,
    mobilePrimaryIconColour: domainMobile?.mobilePrimaryIconColour,
    mobileOtherIconsColour: domainBrand?.domainBrand?.mobileOtherIconsColour,
    mobileSecondaryIconColour: domainMobile?.mobileSecondaryIconColour,
    mobileLoginBoxTextColour: domainMobile?.mobileLoginBoxTextColour,
    mobileOtherButtonTextColour: domainMobile?.mobileOtherButtonTextColour,
    mobileInputBoxColour: domainMobile?.mobileInputBoxColour,
    mobileInputTextColour: domainMobile?.mobileInputTextColour,
    mobileMenuBarHoverButtonColour:
      domainMobile?.mobileMenuBarHoverButtonColour,
    mobileFooterHoverButtonColour: domainMobile?.mobileFooterHoverButtonColour,
    mobileSubMenuLabelTextColour: domainMobile?.mobileSubMenuLabelTextColour,
    mobileTransactionHistoryValueTextColour:
      domainMobile?.mobileTransactionHistoryValueTextColour,
    mobileSubMenuValueTextColour: domainMobile?.mobileSubMenuValueTextColour,
  });

  const updateMobileAppSettings = async (payload) => {
    setLoading(true);
    try {
      const response = await ManagerService.updateMobileAppSettings(payload);
      if (response.status === 200) {
        toast.success(response.data.message);
        dispatch(getMobileDomainBrandIdentity());
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      return error;
    }
    setLoading(false);
  };

  return (
    <>
      <Card>
        <ul className="list-group">
          <li
            className="list-group-item collapse-text text-uppercase fw-bold"
            onClick={() => setColor(!color)}
            aria-controls="example-collapse-text"
            aria-expanded={open}
            style={{ cursor: "pointer", borderBottom: "0px solid" }}
          >
            {color ? (
              <i className="fa fa-minus" aria-hidden="true" />
            ) : (
              <i className="fa fa-plus" aria-hidden="true" />
            )}{" "}
            &nbsp;
            {dictionary ? dictionary["l_color_settings"] : "COLOR SETTINGS"}
          </li>
          <Collapse in={color}>
            <div id="example-collapse-text" className="px-3">
              <h6 className="fw-bold">
                {dictionary
                  ? dictionary[
                      "para_set_primary,_secondary,_background_color..."
                    ]
                  : `Set primary, secondary, background color etc. of your choice here.`}
              </h6>

              {/* submit */}
              <h6 className="fw-bold mx-auto text-uppercase pt-4 text-center mt-5">
                {dictionary
                  ? dictionary["WO_APP_BACKGROUND_SETTI_-1149511853"]
                  : `APP BACKGROUND SETTINGS`}
              </h6>
              <hr />
              <div className="form-row py-4">
                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["WO_MAIN_BACKGROUN_-1803458694"]}`
                      : `Main Background`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.mobileMainBackgroundColour}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        mobileMainBackgroundColour: color?.hex,
                      });
                    }}
                  />
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["WO_LAUNCH_SCREEN_HEADE_-548754736"]}`
                      : `Launch Screen Header`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.mobileLaunchScreenHeaderColour}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        mobileLaunchScreenHeaderColour: color?.hex,
                      });
                    }}
                  />
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["WO_SUBPAGES_BACKGROUN_59941169"]}`
                      : `Subpages Background`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.mobileSubPagesColour}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        mobileSubPagesColour: color?.hex,
                      });
                    }}
                  />
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["WO_MAIN_FOOTE_1813405201"]}`
                      : `Main Footer`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.mobileMainFooterColour}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        mobileMainFooterColour: color?.hex,
                      });
                    }}
                  />
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["WO_MENU_BAR_BACKGROUN_-1868536027"]}`
                      : `Menu Bar Background`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.mobileMenuBarColour}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        mobileMenuBarColour: color?.hex,
                      });
                    }}
                  />
                </div>
              </div>

              {/* regular */}
              <h6 className="fw-bold mx-auto text-uppercase pt-4 mx-auto text-center mt-4">
                {dictionary
                  ? dictionary["WO_LINE_SETTING_-1038198594"]
                  : `LINE SETTINGS`}
              </h6>
              <hr />
              <div className="form-row py-4">
                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["WO_BORDER_LINE_COLOU_-48520917"]}`
                      : `Border Line Colour`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.mobileBorderLineColour}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        mobileBorderLineColour: color?.hex,
                      });
                    }}
                  />
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["WO_DIVIDER_LINE_COLOU_-1212033382"]}`
                      : `Divider Line Colour`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.mobileDividerLineColour}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        mobileDividerLineColour: color?.hex,
                      });
                    }}
                  />
                </div>
              </div>

              {/* delete */}
              <h6 className="fw-bold mx-auto text-uppercase pt-4 mx-auto text-center">
                {dictionary
                  ? dictionary["WO_BUTTON_SETTING_89660088"]
                  : `BUTTON SETTINGS`}
              </h6>
              <hr />
              <div className="form-row py-4">
                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["WO_LOGIN_BOX_BUTTON_COL_-1030156513"]}`
                      : `Login Box Button Colour`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.mobileMainLoginBoxButtonColour}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        mobileMainLoginBoxButtonColour: color?.hex,
                      });
                    }}
                  />
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["WO_OTHER_BUTTON_COLOU_-2042830262"]}`
                      : `Other Button Colour`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.mobileOtherButtonColour}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        mobileOtherButtonColour: color?.hex,
                      });
                    }}
                  />
                </div>
              </div>

              <h6 className="fw-bold mx-auto text-uppercase pt-4 mx-auto text-center">
                {dictionary
                  ? dictionary["WO_ICONS_SETTING_74577316"]
                  : `ICONS SETTINGS`}
              </h6>
              <hr />
              <div className="form-row py-4">
                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["WO_PRIMARY_ICON_COLOU_-4343515"]}`
                      : `Primary Icon Colour`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.mobilePrimaryIconColour}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        mobilePrimaryIconColour: color?.hex,
                      });
                    }}
                  />
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["WO_OTHER_ICON_COLOUR_-300282070"]}`
                      : `Other Icon Colours`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.mobileOtherIconsColour}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        mobileOtherIconsColour: color?.hex,
                      });
                    }}
                  />
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["WO_SECONDARY_ICON_COLOU_-1535850904"]}`
                      : `Secondary Icon Colour`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.mobileSecondaryIconColour}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        mobileSecondaryIconColour: color?.hex,
                      });
                    }}
                  />
                </div>
              </div>

              <h6 className="fw-bold mx-auto text-uppercase pt-4 mx-auto text-center">
                {dictionary
                  ? dictionary["WO_BUTTON_TEXT_SETTING_1324135110"]
                  : `BUTTON TEXT SETTINGS`}
              </h6>
              <hr />
              <div className="form-row py-4">
                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["WO_LOGIN_BOX_BUTTON_TEX_-497439132"]}`
                      : `Login Box Button Text Colour`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.mobileLoginBoxTextColour}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        mobileLoginBoxTextColour: color?.hex,
                      });
                    }}
                  />
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["WO_OTHER_BUTTON_TEXT_CO_-931328073"]}`
                      : `Other Button Text Colour`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.mobileOtherButtonTextColour}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        mobileOtherButtonTextColour: color?.hex,
                      });
                    }}
                  />
                </div>
              </div>

              <h6 className="fw-bold mx-auto text-uppercase pt-4 mx-auto text-center">
                {dictionary
                  ? dictionary["WO_BOX_COLOURS_SETTING_1636947527"]
                  : `BOX COLOURS SETTINGS`}
              </h6>
              <hr />
              <div className="form-row py-4">
                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["WO_INPUT_BOX_COLOU_-1797883689"]}`
                      : `Input Box Colour`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.mobileInputBoxColour}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        mobileInputBoxColour: color?.hex,
                      });
                    }}
                  />
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["WO_INPUT_TEXT_COLOU_388538319"]}`
                      : `Input Text Colour`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.mobileInputTextColour}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        mobileInputTextColour: color?.hex,
                      });
                    }}
                  />
                </div>
              </div>

              <h6 className="fw-bold mx-auto text-uppercase pt-4 mx-auto text-center">
                {dictionary
                  ? dictionary["WO_HOVER_BUTTON_SETTING_-1506931532"]
                  : `HOVER BUTTON SETTINGS`}
              </h6>
              <hr />
              <div className="form-row py-4">
                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["WO_MENU_BAR_HOVER_BUTTO_1660430015"]}`
                      : `Menu Bar Hover Button`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.mobileMenuBarHoverButtonColour}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        mobileMenuBarHoverButtonColour: color?.hex,
                      });
                    }}
                  />
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["WO_FOOTER_HOVER_BUTTO_-1581326676"]}`
                      : `Footer Hover Button`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.mobileFooterHoverButtonColour}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        mobileFooterHoverButtonColour: color?.hex,
                      });
                    }}
                  />
                </div>
              </div>

              <h6 className="fw-bold mx-auto text-uppercase pt-4 mx-auto text-center">
                {dictionary
                  ? dictionary["WO_LABEL_TEXT_SETTING_-1339578033"]
                  : `LABEL TEXT SETTINGS`}
              </h6>
              <hr />
              <div className="form-row py-4">
                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["WO_SUB_MENU_LABEL_TEXT_-101339170"]}`
                      : `Sub Menu Label Text Colour`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.mobileSubMenuLabelTextColour}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        mobileSubMenuLabelTextColour: color?.hex,
                      });
                    }}
                  />
                </div>
              </div>

              <h6 className="fw-bold mx-auto text-uppercase pt-4 mx-auto text-center">
                {dictionary
                  ? dictionary["WO_VALUE_TEXT_SETTING_2022771094"]
                  : `VALUE TEXT SETTINGS`}
              </h6>
              <hr />
              <div className="form-row py-4">
                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["WO_TRANSACTION_HISTORY_-378453150"]}`
                      : `Transaction History Value Text Colour`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.mobileTransactionHistoryValueTextColour}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        mobileTransactionHistoryValueTextColour: color?.hex,
                      });
                    }}
                  />
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["WO_SUB_MENU_VALUE_TEXT_227483179"]}`
                      : `Sub Menu Value Text Colour`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.mobileSubMenuValueTextColour}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        mobileSubMenuValueTextColour: color?.hex,
                      });
                    }}
                  />
                </div>
              </div>

              <div className="form-row py-4">
                <div className="col-lg-6 col-md-6 float-start mb-3">
                  <button
                    // onClick={() => updateRemittanceValue(hideObject)}
                    className="login100-form-btn btn-primary fw-bold text-uppercase"
                  >
                    {dictionary
                      ? dictionary["l_reset_settings"]
                      : "RESET SETTINGS"}
                    &nbsp;&nbsp;
                    {loading && (
                      <>
                        <i className="fa fa-spinner fa-spin" />
                      </>
                    )}
                  </button>
                </div>
                <div className="col-lg-6 col-md-6 float-end mb-3">
                  <button
                    onClick={() => updateMobileAppSettings(colorPallet)}
                    className="login100-form-btn btn-primary fw-bold text-uppercase"
                    type={"button"}
                  >
                    {dictionary
                      ? dictionary["b_update_colors"]
                      : "UPDATE COLORS"}
                    &nbsp;&nbsp;
                    {loading && (
                      <>
                        <i className="fa fa-spinner fa-spin" />
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Collapse>
        </ul>
      </Card>
    </>
  );
}

export default Color;
